<template>
    <v-row>
        <v-col cols="8" class="table-head pa-0 ma-0">
            <v-row no-gutters>
                <v-col cols="12" class="buttom-border table-head">
                    <v-row no-gutters class="top-border">
                        <v-col cols="6">
                            <v-row no-gutters>
                                <v-col cols="12" class="text-center table-head primary--text">Tipo</v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="6">
                            <v-row no-gutters>
                                <v-col cols="12" class="text-center left-border primary--text">Código de impuesto</v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters v-for="tax in taxKeys" :key="tax.id">
                <v-col cols="6" class="buttom-border">
                    <v-row no-gutters>
                        <v-col cols="12" class="text-center align-self-end table-row">
                            <doc-text-field dense hide-details :readonly="true" :value="tax.name" kind="text"></doc-text-field>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="6" class="buttom-border">
                    <v-row no-gutters>
                        <v-col  cols="12" class="table-row">
                            <doc-text-field dense hide-details :readonly="tax.readonly" v-model="aux_taxes[tax.value]" kind="text" @input="updateTaxes"/>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <!-- <v-row no-gutters v-for="tax in Object.keys(taxes_labels)" :key="tax">
                <v-col cols="6" class="buttom-border">
                    <v-row no-gutters>
                        <v-col cols="12" class="text-center align-self-end table-row">
                            <doc-text-field dense hide-details :value="taxes_labels[tax]" kind="text" :readonly="true"></doc-text-field>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="6" class="buttom-border">
                    <v-row no-gutters>
                        <v-col  cols="12" class="table-row">
                            <doc-text-field dense hide-details v-model="aux_taxes[tax]" kind="text" @input="updateTaxes"/>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row> -->

        </v-col>
    </v-row>
</template>

<script>
import DocTextField from './DocTextField.vue';
import { mapFields } from 'vuex-map-fields';
import { DEFAULT_TAX_CODES, getRevisoTaxCodes } from '../modules/conector_ops/domain/CodeTaxes';
import { mapGetters } from 'vuex';

export default {
    name: 'TaxesValuesTables',
    components: {
        DocTextField
    },
    data() {
        return {
            aux_taxes: {},
        };
    },
    props: {
        taxes: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapFields('connector', {
            taxes_labels: 'taxes_labels', 
        }),
        taxKeys() {
            return 'BIn21' in this.aux_taxes ? getRevisoTaxCodes(this.got_feature('feature_additional_vat_reviso')) : DEFAULT_TAX_CODES
        },
        ...mapGetters({
            got_feature: 'got_feature',
        }),
    },
    mounted() {
        if(this.taxes){
            this.aux_taxes = JSON.parse(JSON.stringify(this.taxes));
        }
    },
    methods:{
        updateTaxes() {
            const taxes = { ...this.aux_taxes}
            this.$emit('update-taxes', taxes);
        }
    }
}
</script>

<style scoped>
    .buttom-border {
      border-bottom-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .top-border {
      border-top-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .left-border {
      border-left-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .right-border {
      border-right-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin; 
    }
    .table-head {
        border-left-style:solid;
        border-right-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-row{
        border-left-style:solid;
        border-right-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .title-color {
        color:var(--v-primary-base);
    }
    .dragging_file{
      background: var(--v-neutralDark-base)!important;
      border-radius: 5px;
      border: 2px dashed #ccc;
    }

    .primary-bckground {
      background-color: var(--v-primary-base);
    }
    .primary-border {
      border-color: var(--v-primary-base) !important;
    }
    .table-row >>> div > .v-input {
      margin-top: 0px;
    }
    .table-row >>> div > .v-input > .v-input__control > .v-input__slot {
      padding-bottom: 4px;
    }
    .progress-circular {
      margin: 7%;
    }
</style>
